import { render, staticRenderFns } from "./Command.vue?vue&type=template&id=1af866a4&scoped=true&"
import script from "./Command.vue?vue&type=script&lang=js&"
export * from "./Command.vue?vue&type=script&lang=js&"
import style0 from "./Command.vue?vue&type=style&index=0&id=1af866a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af866a4",
  null
  
)

export default component.exports